export const namespaces = {
  pages: {
    front: 'pages.front',
    letters: 'pages.letters',
    reply: 'pages.reply',
    users: 'pages.users',
    profile: 'pages.profile',
    bookingTypes: 'pages.bookingTypes',
    bookingCalendar: 'pages.booking',
    allBookings: 'pages.allBookings',
    myBookings: 'pages.myBookings',
    settings: 'pages.settings',
    materials: 'pages.materials',
    statusCode: 'pages.statusCode',
  },
  navigation: 'navigation',
};

export const languages = {
  en: 'en',
  fi: 'fi',
};
